import type { FeaturePageSeo } from "@/components/feature-template/seo";
import type { FAQItem } from "@/components/feature-template/types";

// Shared by page.tsx (JSON-LD) and the client page (visible FAQ) so both always match.

export const faqs: FAQItem[] = [
  {
    question: "What is JobTracker AI?",
    answer:
      "A free tracker for every job you save or apply to. It shows your applications as a Kanban board, a detailed list or a stats dashboard, and suggests what to do next.",
  },
  {
    question: "Which stages can I track?",
    answer:
      "Saved, Auto Apply Queue, Applied, Interviewing, Offered, Accepted and Rejected. Drag a card between columns to update its stage.",
  },
  {
    question: "Do I have to add jobs manually?",
    answer:
      "No. Jobs submitted by Auto Apply are added automatically, and you can track any listing from the Job Board in one click. You can also add any job yourself.",
  },
  {
    question: "What do AI Insights show?",
    answer:
      "Applications that need a follow-up, patterns in where you get responses, and upcoming interviews to prepare for, each with practical tips.",
  },
  {
    question: "Can I set follow-up reminders?",
    answer:
      "Yes. Each application has a next follow-up date and a priority, and applications that are due appear in your insights.",
  },
  {
    question: "What stats can I see?",
    answer:
      "Response rate, interview rate, offer rate and rejection rate, plus applications per week and a breakdown by status.",
  },
  {
    question: "Can I keep notes on each application?",
    answer:
      "Yes. Add notes such as referrals, recruiter names or interview feedback to any card so the details are there when you need them.",
  },
];

export const seo: FeaturePageSeo = {
  slug: "jobtracker-ai",
  name: "JobTracker AI",
  title: "Free Job Application Tracker with AI Insights | MindMyJob",
  description:
    "Track every job application on a Kanban board. See response and interview rates, get follow-up reminders and AI insights, with jobs added automatically.",
  keywords: [
    "job application tracker",
    "job search tracker",
    "kanban job tracker",
    "track job applications free",
    "job hunt organizer",
    "application follow-up reminder",
    "job search analytics",
    "interview pipeline tracker",
    "job tracker app",
    "ai job tracker",
  ],
  ogImage: "/assets/images/features/jobtracker-ai/hero-kanban.png",
  ogImageAlt: "MindMyJob JobTracker AI Kanban board with application stages",
  featureList: [
    "Kanban board with seven stages",
    "List view with follow-up dates and priority",
    "Stats dashboard with response, interview and offer rates",
    "AI insights and follow-up suggestions",
    "Automatic tracking from Auto Apply and Job Board",
    "Notes on every application",
  ],
  faqs,
};
